import { promiseCallApi, POST_METHOD, REQUEST_STATUS } from '~/stores/tools/commons';
import { createSlice } from '@reduxjs/toolkit'
import { openBar } from '~/slices/commons/snackbar'


const initialState = {
  info: null,
  addresses: [],
}

// sliceを生成
export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    loginCustomer: (state, action) => {
      return {
        ...state,
        info: action.payload,
      }
    },
    logoutCustomer: (state, action) => {
      return {
        ...state,
        info: action.payload
      }
    },
    changeInfo:(state, action) => {
      return {
        ...state,
        info: action.payload,
      }
    },
    fetchAddresses:(state, action) => {
      return {
        ...state,
        addresses: action.payload,
      }
    },
    addAddress:(state, action) => {
      return {
        ...state,
        addresses: [...state.addresses, action.payload]
      }
    },
    deleteAddress:(state, action) => {
      return {
        ...state,
        addresses: state.addresses.filter(address => address.id != action.payload),
      }
    },
    updateAddress:(state, action) => {
      return {
        ...state,
        addresses: state.addresses.map(address => address.id === action.payload.id ? action.payload : address),
      }
    },
  },
})

export const { loginCustomer, logoutCustomer, changeInfo, fetchAddresses, addAddress, updateAddress, deleteAddress } = customerSlice.actions

// パスワードの変更（マイページ）
export const updatePassword = values => {
  return (async dispatch => {
    const response = await promiseCallApi(`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/v1/customers/update_password.json`, POST_METHOD, values);
    if(response.status === REQUEST_STATUS.CREATED) {
      if(!response.data.error) {
        dispatch(openBar({ message: 'パスワードを変更しました', variant: 'success' }));
        return true;
      }
      else {
        dispatch(openBar({ message: response.data.error, variant:'error' }));
        return false;
      }
    }
    else {
      dispatch(openBar({ message: "パスワードの更新に失敗しました", variant: 'error' }));
      return false;
    }
  });
}

export default customerSlice.reducer
